import { CostBasisCell, CostBasisLegend, CostBasisSummary } from '@wavvest/wealth-ui';
import '@wavvest/wealth-ui/cost-basis.scss';
import { useAccountBasis, useBasisEnabled } from './context';
import { useLotsSource } from './lots';

type Holding = {
  asset_id?: string | null;
  asset_type?: string | null;
  symbol?: string | null;
  cost_basis_metadata?: unknown;
};

/** Cash by instrument identity, as the Apex summary decides (ENG-3447). */
const isCash = (holding: Holding) =>
  holding.asset_type === 'CURRENCY' ||
  holding.asset_id === '1' ||
  (!holding.asset_id && holding.symbol?.toUpperCase() === 'USD');

export function BasisCell({
  accountId,
  holding,
  gain = false,
  external = false,
}: {
  accountId: string;
  holding: Holding;
  gain?: boolean;
  external?: boolean;
}) {
  const basis = useAccountBasis(external ? undefined : accountId);
  const lots = useLotsSource(basis.state?.apexId);
  // Client Portal holdings carry the Apex asset ID directly.
  return (
    <CostBasisCell
      basis={basis}
      holding={holding}
      assetId={holding.asset_id}
      cash={isCash(holding)}
      lots={lots}
      gain={gain}
      external={external}
    />
  );
}

export function AccountBasisSummary({ accountId, name }: { accountId: string; name: string }) {
  const basis = useAccountBasis(accountId);
  const lots = useLotsSource(basis.state?.apexId);
  return <CostBasisSummary basis={basis} name={name} lots={lots} />;
}

export function BasisLegend() {
  return <CostBasisLegend enabled={useBasisEnabled()} />;
}
